import { render, staticRenderFns } from "./TreasureEffectDisplay.vue?vue&type=template&id=6f8c037d&scoped=true"
import script from "./TreasureEffectDisplay.vue?vue&type=script&lang=js"
export * from "./TreasureEffectDisplay.vue?vue&type=script&lang=js"
import style0 from "./TreasureEffectDisplay.vue?vue&type=style&index=0&id=6f8c037d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8c037d",
  null
  
)

export default component.exports